<template>
    <base-modal-focus-lock :show-modal="showModal">
        <transition name="cz3__fade">
            <div
                v-if="showModal"
                @click.self="emitClose"
                :class="position[modalPosition]"
                class="z-50 fixed top-0 left-0 w-full h-full flex flex-col bg-black bg-opacity-30 font-sans"
            >
                <div
                    :class="width[modalSize]"
                    class="relative shadow-md overflow-hidden"
                >
                    <slot name="closeButton">
                        <close-button
                            @click="emitClose"
                            class="absolute top-4 right-4"
                            tabindex="-1"
                            width="16"
                        />
                    </slot>

                    <div
                        v-if="$slots.header"
                        :class="[ padding[paddingSize], { 'border-b border-black': showBorder } ]"
                        :style="{ backgroundImage: `url(${modalImage})` }"
                        class="min-h-[150px] bg-gray-light bg-cover bg-center bg-no-repeat"
                    >
                        <slot name="header" />
                    </div>

                    <div
                        :class="padding[paddingSize]"
                        class="bg-white"
                    >
                        <slot name="content" />
                    </div>
                </div>
            </div>
        </transition>
    </base-modal-focus-lock>
</template>

<script>
    import BaseModalFocusLock from './BaseModalFocusLock.vue';
    import CloseButton from './buttons/CloseButton.vue';

    export default {
        components: {
            BaseModalFocusLock,
            CloseButton,
        },

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
            paddingSize: {
                type: String,
                default: 'small',
            },
            showBorder: {
                type: Boolean,
                default: false,
            },
            modalImage: {
                type: String,
                default: '',
            },
            modalSize: {
                type: String,
                default: 'small',
            },
            modalPosition: {
                type: String,
                default: 'center',
            },
        },

        data() {
            return {
                padding: {
                    small: 'p-[18px] py-[28px]',
                    large: 'p-8 sm:px-12',
                },

                width: {
                    small: 'w-[296px]',
                    medium: 'w-full lg:w-[500px]',
                    large: 'w-11/12 max-w-[970px]',
                },

                position: {
                    center: 'justify-center items-center',
                    bottomleft: 'justify-center items-center lg:justify-end lg:items-start lg:pb-16 lg:pl-10',
                },
            };
        },

        methods: {
            emitClose() {
                this.$emit('modalClose');
            },
        },
    };
</script>
